// import $ from 'jquery';
import Promise from 'bluebird';
import _ from 'lodash';
import environment from '../environment';
import {
    loading,
    notifyError,
    unloading
} from '../shared';
import './binary';
import AuthService from '../../services/authservice';

const fetch = (() => {
    return options => {
        const headers = AuthService.getAccessTokenHeader();

        if (options.header) {
            _.forEach(options.header, (value, key) => {
                headers[key] = value;
            });
        }

        const contentType = _.isNull(options.contentType) || _.isUndefined(options.contentType) ? 'application/json; charset=utf-8' : options.contentType;

        return new Promise((resolve, reject) => {
            $.ajax({
                type: options.type,
                url: options.url,
                crossDomain: true,
                headers,
                data: options.data ? options.data : null,
                dataType: options.dataType || 'json',
                timeout: 120000,
                processData: _.isBoolean(options.processData) ? options.processData : true,
                contentType,
                statusCode: {
                    401() {
                        try {
                            return environment.get('SESSION_ID')
                                ? AuthService.signinPopup()
                                : AuthService.login();
                        } catch (err) {
                            console.log(`ERROR: ${err.message}`);
                        }
                    }
                },

                beforeSend() {
                    try {
                        if (!options.noLoading) {
                            return loading();
                        }
                    } catch (err) {
                        console.log('ERROR: Loading object not ready');
                    }
                },

                complete() {
                    try {
                        unloading();
                    } catch (err) {
                        console.log('ERROR: Loading object not ready');
                    }

                    if (_.isFunction(options.complete)) {
                        return options.complete();
                    }
                },

                error(xhr, textStatus, errorThrown) {
                    try {
                        unloading();
                    } catch (err) {
                        console.log('ERROR: Loading object not ready');
                    }

                    if (_.isFunction(options.error)) {
                        options.error(xhr, textStatus, errorThrown);
                    }

                    if (textStatus === 'timeout') {
                        notifyError(xhr);
                    }

                    return reject(new Error(errorThrown));
                },

                success(res) {
                    if (options.success) {
                        resolve(options.success(res));
                    }

                    resolve(res);
                }
            });
        });
    };
})();

export default fetch;



// WEBPACK FOOTER //
// ./src/scripts/api/fetch.js